import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import EncandoPlatform from './Pages/EncandoPlatform';
import SmartNote from './Pages/SmartNote';
import Company from './Pages/Company';
import Team from './Pages/Team';
import NotFoundPage from './Pages/NotFoundPage';
import InvestorsPage from './Pages/Investors';
import './Styles/App.css';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Company />} />
                <Route path="/product/encando-platform" element={<EncandoPlatform />} />
                <Route path="/product/smart-note" element={<SmartNote />} />
                <Route path="/team" element={<Team />} />
                <Route path="/investors" element={<InvestorsPage />} />
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </Router>
    );
}

export default App;
